module.exports = __webpack_public_path__ + "img/89.626118a4.jpg";